/* eslint-disable @typescript-eslint/no-explicit-any */
import ButtonScrollToTop from '@/components/ButtonScrollToTop'
import Keyword from '@/components/Keyword'
import ModalChooseLocation from '@/components/Popup/ModalChooseLocation'
import { useNotification, useStore } from '@/containers'
import { Footer } from '@/layouts/Footer'
import { Header } from '@/layouts/Header'
import { HeaderBottom } from '@/layouts/HeaderBotom'
import { type BannerList } from '@/types'
import dynamic from 'next/dynamic'
import { type ReactNode } from 'react'
const NotificationBar = dynamic(() => import('@/components/NotificationBar'), {
  ssr: false,
})
const OnDevelopment = dynamic(() => import('@/components/OnDevelopment'), {
  ssr: false,
})
type IMainProps = {
  meta?: ReactNode
  children: ReactNode
  hideFooter?: boolean
  banner?: BannerList[]
  bgColor?: string
  bottomMenu?: any
  style?: any
  page?: string
  className?: string
}
const Main = (props: IMainProps) => {
  const { keywords } = useStore()
  const { systemConfig } = useNotification()
  return (
    <>
      {props.meta}
      <div className=' w-full text-dark-400 antialiased'>
        <Header page={props.page} />
        <HeaderBottom />
        <NotificationBar />
        <ButtonScrollToTop />
        <main
          style={
            props.page === 'homepage'
              ? {
                  backgroundColor: systemConfig?.homepageBgColor
                    ? systemConfig?.homepageBgColor
                    : '#f6f4f5',
                  backgroundImage:
                    systemConfig?.homepageBgImage &&
                    `url(${systemConfig?.homepageBgImage})`,
                  backgroundRepeat:
                    systemConfig?.homepageBgImage && `no-repeat`,
                  backgroundSize: systemConfig?.homepageBgImage && `100% auto`,
                  backgroundPosition:
                    systemConfig?.homepageBgImage && `bottom center`,
                  backgroundAttachment:
                    systemConfig?.homepageBgImage && `fixed`,
                }
              : props.style && props.style
          }
          className={`main-content pt-3 text-base ${
            props.bgColor ? props.bgColor : 'bg-white-500'
          } ${props.className ? props.className : ''}`}
        >
          <div
            className={`mainWrapper mx-auto w-full ${
              props.page === 'homepage' ? '' : 'container'
            }`}
          >
            {props.children}
          </div>
          {!props.hideFooter && <Keyword data={keywords} />}
        </main>
        {!props.hideFooter && <Footer page={props?.page || ''} />}
        <OnDevelopment />
        <ModalChooseLocation />
      </div>
    </>
  )
}

export { Main }
